import { cn } from '../../css/className/className';

import { SkinColor, SkinRole } from './generated/types';

import './generated/getColorSkin.css';

const cls = cn('ColorSkin');

/**
 * Вспомогательная функция, которая навешивает цветовые или ролевые скины на нужный элемент.
 * Создает переменные `dc-current-skin-*`, которые нужно использовать в css компонентов
 * @internal
 * @param color Название цветового или ролевого скина
 * @param param1 Состояние компонента: hovered или disabled
 * @returns className, который нужно передать на элемент
 */
export function getColorSkin(
    color: SkinColor | SkinRole,
    { isHovered, isDisabled }: { isHovered?: boolean; isDisabled?: boolean },
) {
    return cls({ color, hover: isHovered, disabled: isDisabled });
}

/**
 * Вспомогательная функция, которая используется в pixelPerfect-тестах для имитации ховера элемента
 * @internal
 * @returns className, который нужно навесить на элемент
 */
export function getHoverSkin() {
    return cls({ hover: true });
}
